import { useMemo } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useCountryData } from "../../hooks/useCountryData";

export function SendMailInfoAddress(props) {
  const { communityNews } = props;
  const countryCode = communityNews?.country?.code;

  // Use our custom hook to fetch country data
  const { countryData, isLoading } = useCountryData(countryCode);

  const addressLines = useMemo(() => {
    if (!countryData) return [];

    if (countryData.nationalOfficeFullAddress) {
      return countryData.nationalOfficeFullAddress.split('\n');
    }

    // If no nationalOfficeFullAddress, use the individual mail address fields
    const addressArray = [];
    if (countryData.mailAddressLine1) addressArray.push(countryData.mailAddressLine1);
    if (countryData.mailAddressLine2) addressArray.push(countryData.mailAddressLine2);
    if (countryData.mailAddressLine3) addressArray.push(countryData.mailAddressLine3);
    if (countryData.mailAddressLine4) addressArray.push(countryData.mailAddressLine4);
    if (countryData.mailCityDistrict) addressArray.push(countryData.mailCityDistrict);
    if (countryData.mailStateTerritoryCode) addressArray.push(countryData.mailStateTerritoryCode);
    if (countryData.mailCountryCode) addressArray.push(countryData.mailCountryCode);
    if (countryData.mailPostalCode) addressArray.push(countryData.mailPostalCode);

    return addressArray;
  }, [countryData]);

  return (
    <div className="send-mail__child-info-row send-mail__address">
      <FontAwesomeIcon icon={solid("marker")} className="send-mail__child-icon" />
      <div className="send-mail__child-info-content">
        <h4 className="eta">Mailing address:</h4>

        {addressLines.length > 0 ? (
          // Display address lines from country data
          addressLines.map((line, index) => (
            <div key={index} className="address-line">{line.toLowerCase()}</div>
          ))
        ) : (
          // Display loading or unavailable message if no address data
          <div className="address-line">
            {isLoading ?
              "Loading address information..." :
              "Address information unavailable"}
          </div>
        )}
      </div>
    </div>
  );
}

export default SendMailInfoAddress;
